<div class="card card-sticky-header">
  <div class="card-header">
    {{header}}
  </div>
</div>
